import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faCircleDot } from '@fortawesome/pro-regular-svg-icons';
import { JobAcceptType } from '@core/generated/gql-types';

interface AssignmentMethodProps {
  value: JobAcceptType | 'assign';
  onChange: (value: JobAcceptType | 'assign') => void;
  canAssignWorker: boolean;
}

const AssignmentMethod: React.FC<AssignmentMethodProps> = ({
  value,
  onChange,
  canAssignWorker = true,
}) => {
  return (
    <div className="mb-4">
      <label className="mb-2 block text-sm font-medium">
        Assignment Method
      </label>
      <div className={`grid grid-cols-${canAssignWorker ? '3' : '2'} gap-4`}>
        <div
          className={`flex cursor-pointer items-center gap-2 rounded border p-4 hover:bg-gray-50 ${
            value === JobAcceptType.Apply ? 'border-blue-500 bg-blue-50' : ''
          }`}
          onClick={() => onChange(JobAcceptType.Apply)}
        >
          <FontAwesomeIcon
            icon={value === JobAcceptType.Apply ? faCircleDot : faCircle}
            className={`mr-1 ${
              value === JobAcceptType.Apply ? 'text-blue-500' : 'text-gray-300'
            }`}
          />
          <div>
            <div className="mb-1 text-sm font-medium">Apply</div>
          </div>
        </div>

        <div
          className={`flex cursor-pointer items-center gap-2 rounded border p-4 hover:bg-gray-50 ${
            value === JobAcceptType.Accept ? 'border-blue-500 bg-blue-50' : ''
          }`}
          onClick={() => onChange(JobAcceptType.Accept)}
        >
          <FontAwesomeIcon
            icon={value === JobAcceptType.Accept ? faCircleDot : faCircle}
            className={`mr-1 ${
              value === JobAcceptType.Accept ? 'text-blue-500' : 'text-gray-300'
            }`}
          />
          <div>
            <div className="mb-1 text-sm font-medium">Auto-accept</div>
          </div>
        </div>

        {canAssignWorker && (
          <div
            className={`flex cursor-pointer items-center gap-2 rounded border p-4 hover:bg-gray-50 ${
              value === 'assign' ? 'border-blue-500 bg-blue-50' : ''
            }`}
            onClick={() => onChange('assign')}
          >
            <FontAwesomeIcon
              icon={value === 'assign' ? faCircleDot : faCircle}
              className={`mr-1 ${
                value === 'assign' ? 'text-blue-500' : 'text-gray-300'
              }`}
            />
            <div>
              <div className="mb-1 text-sm font-medium">Assign worker</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AssignmentMethod;
